import { AdaaBooleanType } from "../../../../../../../../adaa-types";
import { AdaaHelper } from "../../../../../../../core/utils";
import { AdaaBoolean } from "../../../../../../constants/enums";
import { commonFormatter, SharedFields, textField } from "../../configs";
import {
  AccordionSectionConfigType,
  ListSectionConfigType,
  ScreenSectionConfigType,
  ScreenType,
} from "../../wf-difference.types";

const dataTypeField: ScreenSectionConfigType = {
  field: "dataType",
  label: "metrics.label_data_type",
  view: "normal",
};

const monthDifferenceField: ScreenSectionConfigType = {
  field: "monthDifference",
  label: "metrics.month_difference",
  view: "normal",
};

const dataSourceField = () => {
  const fields = textField("dataSource", { use: "both" }) as ScreenSectionConfigType[];

  return fields.map((field) => ({
    ...field,
    label: field.field === "dataSourceAE" ? "metrics.data_source_ae" : "metrics.data_source_en",
  }));
};

const availableField: ScreenSectionConfigType = {
  field: "available",
  label: "metrics.available",
  view: "normal",
  format: (data: { available: AdaaBoolean }) => {
    if (!AdaaHelper.isDefined(data.available)) return commonFormatter.matchYesNo(AdaaBoolean.N);
    return commonFormatter.matchYesNo(data?.available);
  },
  hasDiff: ($newValue: unknown, $oldValue: unknown) => {
    const newValue = $newValue as AdaaBooleanType | null;
    const oldValue = $oldValue as AdaaBooleanType | null;
    if (newValue === AdaaBoolean.N && !AdaaHelper.isDefined(oldValue)) return false;
    if (oldValue === AdaaBoolean.N && !AdaaHelper.isDefined(newValue)) return false;
    return oldValue !== newValue;
  },
};

const validForFutureField: ScreenSectionConfigType = {
  field: "validForFuture",
  label: "metrics.valid_for_future",
  view: "normal",
  format: (data: { validForFuture: boolean }) => commonFormatter.matchTrueFalse(data.validForFuture),
};

const dashboardTypeField: ScreenSectionConfigType = {
  field: "dashboardType",
  label: "metrics.dashboard_type",
  view: "normal",
};

const parentMetricEntityIdField: ScreenSectionConfigType = {
  field: "parentMetricEntityId",
  label: "common.form.label.entity",
  view: "normal",
};

const parentMetricIdField: ScreenSectionConfigType = {
  field: "parentMetricId",
  label: "metrics.parent_metric",
  view: "normal",
};

// Dimensions section
const dimensionsValuesField: ListSectionConfigType = {
  field: "dimensionValues",
  label: "common.form.label.values",
  view: "list",
  idKey: "id",
};

const dimensionNameField: () => ScreenSectionConfigType[] = () => {
  const fields = textField("dimensionName", { use: "both" }) as ScreenSectionConfigType[];

  return fields.map((field) => ({
    ...field,
    label: `common.form.label.${field.field === "dimensionNameAE" ? "nameAE" : "nameEN"}`,
  }));
};

const dimensionsConfig: ScreenSectionConfigType[] = [...dimensionNameField(), dimensionsValuesField];

const dimensionsField: AccordionSectionConfigType = {
  view: "accordion",
  field: "dimensions",
  title: ($o: unknown) => AdaaHelper.getItemValueByToken($o, "dimensionName"),
  idKey: "dimensionId",
  config: dimensionsConfig,
  label: "dimension.dimension",
};
// End Of Dimensions section

export const monitoringMetricsScreenConfig = {
  type: "metrics" as ScreenType,
  sections: [
    ...SharedFields.name,
    ...SharedFields.description,
    dataTypeField,
    monthDifferenceField,
    ...dataSourceField(),
    availableField,
    validForFutureField,
    dashboardTypeField,
    parentMetricEntityIdField,
    parentMetricIdField,
    dimensionsField,
  ],
};
